import {
  applyMiddleware,
  compose,
  createStore,
  Reducer,
  Store,
  StoreEnhancer,
} from "redux";
import thunk from "redux-thunk";

export const getStore = <S>(reducer: Reducer<S>): Store<S> =>
  createStore(
    reducer,
    (window as any).__REDUX_DEVTOOLS_EXTENSION__
      ? compose(
          applyMiddleware(thunk),
          (window as any).__REDUX_DEVTOOLS_EXTENSION__()
        )
      : applyMiddleware(thunk)
  ) as any;
